import React, { PureComponent } from "react";

import { withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";

import LocaleContext from "../../../i18n/LocaleContext";

import styles from "./styles";

class Footer extends PureComponent {
  static contextType = LocaleContext;

  render() {
    const { application, classes } = this.props;
    const t = this.context;
    return (
      <div className={classes.root}>
        <Typography className={classes.line1} variant="body1" gutterBottom>
          {t("Need Help? Call")} <a href="tel:888-241-8393">888-241-8393</a>
        </Typography>
        {application.id && (
          <Typography className={classes.line2} variant="body1">
            {t("Application Number:")} {application.id}
          </Typography>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Footer);
